import { IDeclaredSale } from '../models/declared-sales.model';
import { IDeclaredSales } from '../models/financing-negotiations.model';
import { BalancePeriodUtils } from './balance-period.utils';

export class DeclaredSalesUtils {

  /**
   * Normaliza `declaracionesVentas` de current-balance: período (array de Java o string) → 'YYYY-MM',
   * descarta registros sin período o monto inválido y ordena cronológicamente.
   */
  static fromBackend(list: IDeclaredSales[] | null | undefined): IDeclaredSale[] {
    return (list ?? [])
      .map(sale => ({
        id: sale?.id,
        periodo: BalancePeriodUtils.normalize(sale?.periodo ?? null),
        monto: Number(sale?.monto)
      }))
      .filter(sale => !!sale.periodo && !isNaN(sale.monto))
      .sort((x, y) => x.periodo.localeCompare(y.periodo));
  }

  static total(sales: IDeclaredSale[] | null | undefined): number {
    return (sales ?? []).reduce((sum, sale) => sum + (Number(sale.monto) || 0), 0);
  }
}
